module.exports = __webpack_public_path__ + "img/php-logo-basic.695fc8c1.svg";